import './styles.css'
import {ReactComponent as SquareIcon} from "../../icons/square-right-icon.svg";

const AdvantageCard = (props) => {
    const {
        icon,
        title,
        desc
    } = props;
    return (
        <div className='card-a'>
            <div className='card-a-title-ctn'>
                {icon}
                <div className='card-a-title'>{title}</div>
            </div>
            <div className='card-a-desc'>
                {desc.map(item =>
                    <div className='card-a-desc-item' key={item.text}>
                        <SquareIcon /> {item.text}
                    </div>
                )}
            </div>
        </div>
    )
}

export default AdvantageCard